import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  containerLarge: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  containerSmall: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 50
  },
  headerSmall: {
    flexDirection: 'row',
    padding: 10,
  },
  arrowIconLarge: {
    flex: 0.10,
    alignSelf: 'center',
  },
  arrowIconSmall: {
    alignSelf: 'center',
    flex: 0.3,
  },
  imageLarge: {
    width: 23,
    height: 19,
    marginRight: 10,
  },
  imageSmall: {
    width: 15,
    height: 12,
    marginLeft: '10%',
    marginRight: 8,
    alignSelf: 'center',
  },
  titleTextLarge: {
    flex: 0.2,
    marginLeft: '0.5%',
    color: '#fff',
    alignSelf: 'center',
    fontSize: 16,
    fontWeight: '700',
  },
  titleTextSmall: {
    flex: 0.55,
    marginLeft: '3%',
    alignSelf: 'center',
    justifyContent: 'center',
    color: '#001639',
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    letterspacing: 0.25
  },
  upperTextContainerLarge: { 
    flexDirection: "column", 
    alignSelf: "flex-end", 
    marginTop: 45, 
    flex: 1
  },
  textTitleLargeCommerce: {
    color: "#807F7F"
  },
  textTitleLargeOrders: {
    flex: 0.2,
    color: '#000000',
    flexDirection: "row",
    alignSelf: 'flex-start',
    justifyContent: "flex-start",
    fontSize: 22,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: "left"
  },
  iconLarge: {
    flex: 0.2,
    alignSelf: 'center',
    justifyContent: "center"
  },
  iconSmall: {
    flex: 0.15,
    alignSelf: 'center',
  },
  inputContainerLarge: {
    backgroundColor: '#f3f3f323',
    marginTop: '1%',
    width: '20%',
    alignSelf: 'center',
    color: '#fff',
  },
  input: {
    color: '#fff',
    width: '50%',
    paddingLeft: 20,
    fontFamily: 'Circular-Std-Book',
  },
  btnContainerLarge: {
    width: '20%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: '1%',
    marginBottom: "5%",
    borderRadius: 4,
  },
  iframeDisplay: {
    display: 'none',
  },
  btnContainerSmall: {
    width: '80%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginBottom: '2%',
    borderRadius: 4,
  },
  btnActionTitle: {
    color: '#FFFFFF',
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 16,
    paddingVertical: 6,
    paddingHorizontal: 6
  },
  btnPrintTitle: {
    color: '#000000',
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 16,
    paddingVertical: 6,
    paddingHorizontal: 6
  },
  printBtn: {
    backgroundColor: '#fff',
    borderWidth: 3,
  },
  leftBtn: {
    marginRight: '1rem',
  },
  buttonContainer: {
    marginTop: 1,
  },
  buttonContainerMedium: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: "space-evenly",
  },
  identificationCheckboxContainerLarge: {
    flexDirection: 'row',
    marginBottom: '1%',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  identificationCheckboxContainerSmall: {
    flexDirection: 'column',
    marginTop: '1%',
    flexWrap: 'wrap',
    width: '95%',
    alignSelf: 'center',
  },
  checkBoxText: {
    fontWeight: 'normal',
  },
});
